import { Component, Input } from '@angular/core';

import { FiltersComponent } from '../../common/filters.component';
import { DateService } from '../../common/date.service';

@Component({
	selector: 'app-tourism-events-filters',
	templateUrl: './tourism-events-filters.component.html',
	styleUrls: ['./tourism-events-filters.component.css'],
})
export class TourismEventsFiltersComponent extends FiltersComponent {
	@Input() statuses: Array<any>;
	@Input() categories: Array<any>;
	@Input() vehicle_busTypes: Array<any>;
	@Input() vehicle_statuses: Array<any>;
	@Input() yesno: Array<any>;
	@Input() users: Array<any>;
	@Input() filters = {
		date_from: null,
		date_to: null,
		status: null,
		vehicle: null,
		showDeleted: null,
		showSettled: null,
		search: null,
		category: null,
		vehicle_busType: null,
		vehicle_status: null,
		driver_informed_departure: null,
		driver_informed_return: null,
		guide_informed: null,
		owners: null,
		organizationOwner: null,
		haveOpinion: null,
	};

	filtersDefault() {
		this.filtersClear();
		const date = new DateService();
		this.filters.showDeleted = 0;
		this.filters.vehicle_status = ['1', '5', '7'];
	}
}
